const URLs = {
    gateway: 'https://cors-anywhere.herokuapp.com/',
}

export default URLs;



// WEBPACK FOOTER //
// ./src/conf/URLs.js